<template>
  <svg width="24" height="22" viewBox="0 0 24 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24 7.52502C24 9.55438 23.2438 11.4129 21.62 13.3719C20.1671 15.125 18.0795 16.9042 15.6616 18.9645C14.8354 19.6684 13.8992 20.4664 12.9278 21.3163C12.6733 21.539 12.3472 21.6626 12.0084 21.6646H12C11.6583 21.6646 11.3289 21.5408 11.0722 21.316C10.1027 20.4682 9.16791 19.6711 8.3432 18.9682L8.33899 18.9651C5.92145 16.9046 3.83295 15.125 2.38037 13.3719C0.756226 11.4129 0 9.55438 0 7.52502C0 5.55316 0.676208 3.73364 1.90393 2.40192C3.14648 1.05426 4.8512 0.3125 6.70459 0.3125C8.09015 0.3125 9.35852 0.750122 10.4756 1.61383C11.0394 2.04999 11.5501 2.58319 12 3.20593L12.0084 3.19476C12.4565 2.57678 12.9644 2.04724 13.5247 1.61383C14.6415 0.750122 15.9104 0.3125 17.2954 0.3125C19.1492 0.3125 20.8539 1.05426 22.0961 2.40192C23.3238 3.73364 24 5.55261 24 7.52502Z"
      fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'Favorite',
};

</script>
